import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";

export const ORIENTATIONS = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait",
};

export const DEFAULT_ORIENTATION = ORIENTATIONS.LANDSCAPE;

const OrientationToggle = ({ value, onChange, size = "small", sx }) => {
  const handleChange = (event, nextOrientation) => {
    // The group reports null when the active button is clicked again; keep the
    // current orientation rather than leaving the card without one.
    if (nextOrientation) {
      onChange(nextOrientation);
    }
  };

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      size={size}
      onChange={handleChange}
      aria-label="Race card orientation"
      sx={sx}
    >
      <ToggleButton value={ORIENTATIONS.LANDSCAPE} aria-label="Landscape">
        Landscape
      </ToggleButton>
      <ToggleButton value={ORIENTATIONS.PORTRAIT} aria-label="Portrait">
        Portrait
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default OrientationToggle;
